import React from 'react';
import { Download, FileCode, FileText, Globe, ArrowRight, CheckCircle } from 'lucide-react';

const DownloadPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-32 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-purple-600 to-purple-700 rounded-full mb-6">
            <Download size={40} className="text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            Tải Website Xuống
          </h1>
          <p className="text-xl text-purple-500">
            Chọn phiên bản phù hợp với nhu cầu của bạn
          </p>
        </div>

        {/* Download Options */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {/* Source Code */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-200 hover:border-purple-600 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-100 to-purple-200 rounded-xl mb-6">
              <FileCode size={32} className="text-purple-600" />
            </div>
            <h3 className="text-2xl font-bold text-purple-600 mb-3">
              Source Code React
            </h3>
            <div className="flex items-center space-x-2 text-sm text-purple-500 mb-4">
              <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full font-medium">
                852 KB
              </span>
              <span className="text-gray-400">•</span>
              <span>ZIP File</span>
            </div>
            <p className="text-purple-500 mb-6 leading-relaxed">
              Toàn bộ source code React để bạn có thể chỉnh sửa và phát triển thêm tính năng.
            </p>
            
            <div className="space-y-2 mb-6">
              <div className="flex items-start space-x-2">
                <CheckCircle size={20} className="text-purple-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-purple-600">Components & Pages đầy đủ</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle size={20} className="text-purple-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-purple-600">Dễ chỉnh sửa và tùy chỉnh</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle size={20} className="text-purple-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-purple-600">Có thể phát triển thêm</span>
              </div>
            </div>

            <a
              href="/thepalmgate-source-code.zip"
              download
              className="block w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white text-center px-6 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200"
            >
              <span className="flex items-center justify-center space-x-2">
                <Download size={20} />
                <span>Tải Source Code</span>
              </span>
            </a>
          </div>

          {/* Static HTML */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-purple-600 hover:border-purple-600 transition-all duration-300 hover:shadow-xl relative">
            <div className="absolute top-4 right-4 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full">
              KHUYÊN DÙNG
            </div>
            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-300 rounded-xl mb-6">
              <Globe size={32} className="text-purple-600" />
            </div>
            <h3 className="text-2xl font-bold text-purple-600 mb-3">
              HTML Static (Build)
            </h3>
            <div className="flex items-center space-x-2 text-sm text-purple-500 mb-4">
              <span className="bg-gray-100 text-purple-700 px-3 py-1 rounded-full font-medium">
                890 KB
              </span>
              <span className="text-gray-400">•</span>
              <span>ZIP File</span>
            </div>
            <p className="text-purple-500 mb-6 leading-relaxed">
              File HTML/CSS/JS đã build sẵn, tối ưu hóa, sẵn sàng deploy ngay lập tức.
            </p>
            
            <div className="space-y-2 mb-6">
              <div className="flex items-start space-x-2">
                <CheckCircle size={20} className="text-purple-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-purple-600">Deploy ngay không cần cài đặt</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle size={20} className="text-purple-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-purple-600">Tối ưu hiệu suất</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle size={20} className="text-purple-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-purple-600">Upload trực tiếp lên hosting</span>
              </div>
            </div>

            <a
              href="/thepalmgate-production-build.zip"
              download
              className="block w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white text-center px-6 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200"
            >
              <span className="flex items-center justify-center space-x-2">
                <Download size={20} />
                <span>Tải HTML Build</span>
              </span>
            </a>
          </div>
        </div>

        {/* Documentation */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 mb-8">
          <h3 className="text-2xl font-bold text-purple-600 mb-6 flex items-center">
            <FileText className="mr-3 text-purple-600" size={28} />
            Tài Liệu Hướng Dẫn
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a
              href="/HUONG-DAN-CAI-DAT.md"
              download
              className="flex items-center justify-between bg-white p-4 rounded-xl hover:shadow-md transition-all duration-200 group"
            >
              <div className="flex items-center space-x-3">
                <FileText size={24} className="text-purple-500" />
                <div>
                  <p className="font-semibold text-purple-600">Hướng Dẫn Cài Đặt</p>
                  <p className="text-sm text-purple-500">Chi tiết cách setup & deploy</p>
                </div>
              </div>
              <ArrowRight className="text-gray-400 group-hover:text-purple-600 group-hover:translate-x-1 transition-all" size={20} />
            </a>
            <a
              href="/README-TAI-XUONG.md"
              download
              className="flex items-center justify-between bg-white p-4 rounded-xl hover:shadow-md transition-all duration-200 group"
            >
              <div className="flex items-center space-x-3">
                <FileText size={24} className="text-purple-500" />
                <div>
                  <p className="font-semibold text-purple-600">README</p>
                  <p className="text-sm text-purple-500">Tổng quan về website</p>
                </div>
              </div>
              <ArrowRight className="text-gray-400 group-hover:text-purple-600 group-hover:translate-x-1 transition-all" size={20} />
            </a>
          </div>
        </div>

        {/* Quick Guide */}
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
          <h3 className="text-2xl font-bold text-purple-600 mb-6">
            Hướng Dẫn Nhanh
          </h3>
          
          <div className="space-y-6">
            <div>
              <h4 className="font-semibold text-purple-600 mb-2">
                📦 Nếu tải Source Code:
              </h4>
              <div className="bg-gray-50 rounded-lg p-4 font-mono text-sm">
                <div>1. Giải nén file</div>
                <div>2. cd frontend</div>
                <div>3. yarn install</div>
                <div>4. yarn start</div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-purple-600 mb-2">
                🚀 Nếu tải HTML Build:
              </h4>
              <div className="bg-gray-50 rounded-lg p-4 font-mono text-sm">
                <div>1. Giải nén file</div>
                <div>2. Upload thư mục app/frontend/build/ lên hosting</div>
                <div>3. Website hoạt động ngay!</div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-purple-600 mb-2">
                🌐 Deploy Miễn Phí:
              </h4>
              <ul className="space-y-2 text-purple-600">
                <li className="flex items-start space-x-2">
                  <span className="text-purple-600">•</span>
                  <span><strong>Netlify:</strong> Kéo thả thư mục build/ vào https://app.netlify.com/drop</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-purple-600">•</span>
                  <span><strong>Vercel:</strong> Import project tại https://vercel.com</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-purple-600">•</span>
                  <span><strong>GitHub Pages:</strong> Push lên GitHub và bật Pages</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="inline-flex items-center text-purple-600 hover:text-purple-700 font-semibold"
          >
            ← Quay lại trang chủ
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
